module.exports = __webpack_public_path__ + "static/media/about-02.1ec5a089.png";